import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from '../Slider.styles';

var NavChevron = function NavChevron(_ref) {
  var contentLength = _ref.contentLength,
      goToSlide = _ref.goToSlide,
      isPrevious = _ref.isPrevious,
      slidingFromDirection = _ref.slidingFromDirection,
      currentIndex = _ref.currentIndex,
      nextIndex = _ref.nextIndex,
      previousIndex = _ref.previousIndex,
      isInfiniteCycle = _ref.isInfiniteCycle,
      display = _ref.display,
      navStyle = _ref.navStyle,
      dataTest = _ref['data-test'],
      className = _ref.className;
  if (!display) return null;
  var chevronIconSize = {
    height: '18px',
    width: '18px'
  };

  var _ref2 = isPrevious ? [previousIndex, 'left', !isInfiniteCycle && currentIndex === 1] : [nextIndex, 'right', !isInfiniteCycle && currentIndex === contentLength],
      _ref3 = _slicedToArray(_ref2, 3),
      index = _ref3[0],
      chevronDir = _ref3[1],
      isDisabled = _ref3[2];

  var ariaLabel = slidingFromDirection === 'right' ? 'Go to next slide' : 'Go to previous slide';
  return /*#__PURE__*/React.createElement(Styled.NavChevron, {
    "aria-label": ariaLabel,
    onClick: function onClick(event) {
      return goToSlide(index, slidingFromDirection, event);
    },
    disabled: isDisabled,
    "data-test": "".concat(dataTest, "-chevron-").concat(chevronDir),
    className: className,
    navStyle: navStyle
  }, /*#__PURE__*/React.createElement(Styled.NavChevronIcon, _extends({}, chevronIconSize, {
    dir: chevronDir
  })));
};

NavChevron.displayName = 'NavChevron';
NavChevron.propTypes = {
  goToSlide: PropTypes.func.isRequired,
  nextIndex: PropTypes.number.isRequired,
  previousIndex: PropTypes.number.isRequired,
  isPrevious: PropTypes.bool,
  navStyle: PropTypes.oneOf(['default', 'withSlideCount'])
};
export default NavChevron;